// Curated "trending" search terms shown in the header dropdown's first-open (empty) state, before the user
// types. Each links to a live search. Swap for real popular queries from the `search.viewed` Ahoy data
// later; keep terms the codex actually has so they don't dead-end.
export const TRENDING_SEARCHES = [
  "sláinte",
  "grá",
  "samhain",
  "ceol",
  "féile",
  "beannachtaí",
]
